import { ApiErrors } from '@customer-apps/shared/enums';
import { EnumDictionary } from '@customer-apps/shared/utils';

export const ApiErrorsMessageDictionary: EnumDictionary<ApiErrors, string> = {
    [ApiErrors.AddressUsedInOpenedProject]: 'API_ERRORS.ADDRESS_USED_IN_OPENED_PROJECT',
    [ApiErrors.AddressUsedInClosedProject]: 'API_ERRORS.ADDRESS_USED_IN_CLOSED_PROJECT',
    [ApiErrors.SFUnableToLockRow]: 'API_ERRORS.SALESFORCE_API_ERROR_UNABLE_TO_LOCK_ROW',
    [ApiErrors.Generic]: 'COMMON.ERRORS.SOMETHING_WRONG'
};
